import React from 'react';

export const CreateShippings = React.lazy(
  () => import('./CreateShippings/CreateShippings')
);
export const CloneShipping = React.lazy(
  () => import('./CloneShipping/CloneShipping')
);
export const ViewShipping = React.lazy(
  () => import('./ViewShipping/ViewShipping')
);
export const EditShipping = React.lazy(
  () => import('./EditShipping/EditShipping')
);
export const RouteBuilder = React.lazy(
  () => import('./RouteBuilder/RouteBuilder')
);
export const Locations = React.lazy(
  () => import('./Locations/Locations')
);
export const PickupAudit = React.lazy(
  () => import('./PickupAudit/PickupAudit')
);
export const MeliOrders = React.lazy(
  () => import('./MeliOrders/MeliOrders')
);
export const ImportShippings = React.lazy(
  () => import('./ImportShippings/ImportShippings')
);
export const CorreoDeliveriesImport = React.lazy(
  () => import('./CorreoDeliveriesImport/CorreoDeliveriesImport')
);
